import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../../lib/constants/reference-data-option-lists';
import { Applicant } from '../../../models/applicant.model';
import { MortgageApplication } from '../../../models/mortgage-application.model';
import { OutstandingDebt } from '../../../models/outstanding-debt.model';

@Component({
  selector: 'boi-applicant-outgoing',
  templateUrl: './applicant-outgoing.component.html',
  styleUrls: ['./applicant-outgoing.component.scss']
})
export class ApplicantOutgoingComponent {
  @Input() public index: number;
  @Input() public outgoing: OutstandingDebt;
  @Input() public mortgageApplication: MortgageApplication;

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public disabledCheckboxIndex: number;
  public get validationApplicantIndex(): number {
    return this.outgoing.ApplicantOrderIds[0] - 1;
  }
  public get validationOutstandingIndex(): number {
    const applicantIndex = this.validationApplicantIndex;
    const applicant = this.mortgageApplication.Applicants[applicantIndex];

    return applicant && applicant.OutstandingDebts ? applicant.OutstandingDebts.indexOf(this.outgoing) : this.index;
  }

  public isOutgoingApplyedToApplicant(applicant: Applicant): boolean {
    return this.outgoing.ApplicantOrderIds.some(
      (applicantIndex) => applicantIndex === applicant.ApplicantTransactOrder
    );
  }

  public isApplicantCheckboxDisabled(applicant: Applicant): boolean {
    return (
      this.outgoing.ApplicantOrderIds.length === 1 &&
      this.outgoing.ApplicantOrderIds[0] === applicant.ApplicantTransactOrder
    );
  }

  public applyedToSelectionChanged(isSelected: boolean, applicant: Applicant): void {
    if (isSelected) {
      this.applyOutgoing(applicant);
    } else {
      this.detachOutgoingWithMainApplicantChange(applicant);
    }
  }

  private applyOutgoing(applicant: Applicant): void {
    this.outgoing.ApplicantOrderIds.push(applicant.ApplicantTransactOrder);
    this.outgoing.ApplicantOrderIds.sort((n1, n2) => n1 - n2);
    applicant.OutstandingDebts.push(this.outgoing);
    applicant.OutstandingDebts.sort((o1, o2) => (new Date(o1.CreatedDate) > new Date(o2.CreatedDate) ? 1 : -1));
  }

  private detachOutgoing(applicant: Applicant): void {
    this.outgoing.ApplicantOrderIds.splice(
      this.outgoing.ApplicantOrderIds.indexOf(applicant.ApplicantTransactOrder),
      1
    );
    applicant.OutstandingDebts.splice(
      applicant.OutstandingDebts.indexOf(
        applicant.OutstandingDebts.find((o) => o.OutstandingDebtID === this.outgoing.OutstandingDebtID)
      ),
      1
    );
  }

  private detachOutgoingWithMainApplicantChange(applicant: Applicant): void {
    const applicantOrderIndex = this.outgoing.ApplicantOrderIds.indexOf(applicant.ApplicantTransactOrder);
    this.detachOutgoing(applicant);
    if (applicantOrderIndex === 0) {
      this.changeMainApplicant();
    }
  }

  private changeMainApplicant(): void {
    const mainApplicantWithOugoing = this.mortgageApplication.Applicants.find(
      (a) => a.ApplicantTransactOrder === this.outgoing.ApplicantOrderIds[0]
    );
    const outgoing = mainApplicantWithOugoing.OutstandingDebts.find(
      (o) => o.OutstandingDebtID === this.outgoing.OutstandingDebtID
    );
    mainApplicantWithOugoing.OutstandingDebts.splice(mainApplicantWithOugoing.OutstandingDebts.indexOf(outgoing), 1);
    mainApplicantWithOugoing.OutstandingDebts.push(this.outgoing);
    mainApplicantWithOugoing.OutstandingDebts.sort((o1, o2) =>
      new Date(o1.CreatedDate) > new Date(o2.CreatedDate) ? 1 : -1
    );
  }

  public primarilyResponsibleSelectionChanged(applicant: Applicant): void {
    this.mortgageApplication.Applicants.filter((a) =>
      a.OutstandingDebts.some((o) => o.OutstandingDebtID === this.outgoing.OutstandingDebtID)
    ).forEach((a) => this.detachOutgoing(a));
    this.applyOutgoing(applicant);
  }

  public isMaintananceOrSchoolFees(outgoing: OutstandingDebt): boolean {
    return (
      outgoing.DebtOutgoingTypeCode === this.referenceDataOptionLists.DebtTypeMaintenance ||
      outgoing.DebtOutgoingTypeCode === this.referenceDataOptionLists.DebtTypeSchoolFees
    );
  }
}
